import {createSlice} from '@reduxjs/toolkit'

declare global {
    interface Window {
        StoreConfig: any;
        Shifts: Record<string, any[]>;
    }
}

const DAY_NAMES: Record<string, string> = {
    '1': 'monday',
    '2': 'tuesday',
    '3': 'wednesday',
    '4': 'thursday',
    '5': 'friday',
    '6': 'saturday',
    '7': 'sunday',
}

function secondsToTime24(seconds: number): string {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}

function mergeShiftsIntoStores(storeConfig: any): any {
    if (!storeConfig?.stores) return storeConfig

    const shifts = window.Shifts ?? {}

    const enrichedStores = storeConfig.stores
        .filter((store: any) => !store.isHiddenFromMultistore)
        .map((store: any) => {
        const storeShifts = shifts[store.storeId]
        if (!storeShifts || storeShifts.length === 0) {
            return { ...store, shifts: {} }
        }

        const shiftsByDay: Record<string, any> = {}
        for (const shift of storeShifts) {
            const dayName = DAY_NAMES[shift.day]
            if (!dayName) continue

            const mapped = {
                start: secondsToTime24(shift.deliveryStart ?? 0),
                end: secondsToTime24(shift.deliveryEnd ?? 0),
                delivery24: shift.delivery24 ?? false,
                deliveryEnd: shift.deliveryEnd ?? 0,
                deliveryStart: shift.deliveryStart ?? 0,
                deliveryStartDisplay: shift.deliveryStartDisplay ?? '',
                deliveryEndDisplay: shift.deliveryEndDisplay ?? '',
                deliveryType: shift.deliveryType ?? '',
                isCurrent: shift.isCurrent ?? false,
                isDeliveryOn: shift.isDeliveryOn ?? false,
                isDeliveryOpen: shift.isDeliveryOpen ?? false,
                isOrderingPaused: shift.isOrderingPaused ?? false,
                noDelivery: shift.noDelivery ?? false,
                noDineIn: shift.noDineIn ?? false,
                noPickup: shift.noPickup ?? false,
                openingEnd: shift.openingEnd ?? 0,
                openingEndDisplay: shift.openingEndDisplay ?? '',
                openingStart: shift.openingStart ?? 0,
                openingStartDisplay: shift.openingStartDisplay ?? '',
                pickup24: shift.pickup24 ?? false,
                restaurant24: shift.restaurant24 ?? false,
                restaurantEnd: shift.restaurantEnd ?? 0,
                restaurantEndDisplay: shift.restaurantEndDisplay ?? '',
                restaurantId: shift.restaurantId ?? '',
                restaurantStart: shift.restaurantStart ?? 0,
                restaurantStartDisplay: shift.restaurantStartDisplay ?? '',
                storeId: shift.storeId ?? '',
            }

            // Prefer the isCurrent=true shift if multiple shifts share the same day
            if (!shiftsByDay[dayName] || mapped.isCurrent) {
                shiftsByDay[dayName] = mapped
            }
        }

        return { ...store, shifts: shiftsByDay }
    })

    return { ...storeConfig, stores: enrichedStores }
}

const initialState = {
    store: mergeShiftsIntoStores(window.StoreConfig ?? null),
    loading: false,
    error: null as string | null,
}

console.log('StoreSlice initial data from window.StoreConfig:', initialState)

export const storeSlice = createSlice({
    name: 'store',
    initialState,
    reducers:{
        setStore:(state,action)=>{
            state.store = mergeShiftsIntoStores(action.payload);
            state.loading = false;
            state.error = null;
        },
        setStoreLoading:(state,action)=>{
            state.loading = action.payload;
        },
        setStoreError:(state,action)=>{
            state.error = action.payload;
            state.loading = false;
        }
    }
})

export const {setStore, setStoreLoading, setStoreError}=storeSlice.actions;
export default storeSlice.reducer;